import { FC } from "react";
import { ExpertisePage } from "./ExpertisePage";

const ExpertiseWrapper: FC = () => {
  return (
    <div>
      <ExpertisePage />
    </div>
  )
}

export { ExpertiseWrapper }